window.onload = function () {
  var nav = document.getElementById('navs');
  var nav_items = nav.getElementsByTagName('li');
  var nav_detail_ids = ['product', 'ordersandshipping', 'returnandrefund', 'general'];
  var question_conts = document.getElementsByClassName('question-cont');
  
  // FOR MOBILE
  
  var mobile_navs = document.getElementsByClassName('mobile-nav');
  var title = {
      product: 'Products',
      returnandrefund: 'Return & Refund',
      ordersandshipping: 'Orders & Shipping',
      general: 'General'
  }
  
  Array.from(nav_items).forEach(li => {
      li.addEventListener('click', function() {
          this.classList.add('active-nav');
          Array.from(nav_items).forEach(i => {
              if (this.dataset.name != i.dataset.name) {
                  i.classList.remove('active-nav');
              }
          });
          
          nav_detail_ids.forEach(id => {
              var details = document.getElementById(id);
              if (this.dataset.name == id) {
                  let question_details = details.getElementsByClassName('detail-cont')[0].firstChild.nextElementSibling
                    .getElementsByClassName('details')[0];
                  question_details.classList.remove('hidden');
                  details.style.display = 'block';
              } else {
                  details.style.display = 'none';
              }
          })
      });
  });
  
  Array.from(question_conts).forEach(question => {
      question.addEventListener('click', function () {
          var detail = this.parentNode.getElementsByClassName('details');
          if (Array.from(detail[0].classList).includes('hidden')) {
              detail[0].classList.remove('hidden');
          } else {
              detail[0].classList.add('hidden');
          }

          Array.from(question_conts).forEach(q => {
              if (this != q) {
                  q.parentNode.getElementsByClassName('details')[0].classList.add('hidden');
              }
          });
      });
  });
  
  Array.from(mobile_navs).forEach(nav => {
      nav.addEventListener('click', function () {
          this.style.display = 'none';
  
  
          //TODO: Get the page title container
          var page_title = document.getElementById('shopify-section-template--22615804018994__main')
              .getElementsByClassName('page-title')[0];
  
          page_title.innerHTML = title[this.dataset.name];
          page_title.style.position = 'relative';
  
          var p = document.createElement('p');
          p.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0847/4643/6903/files/ArrowRight.png?v=1707939012" alt="">`;
          p.classList.add('arrow-left');
  
          page_title.appendChild(p);
  
          document.getElementsByClassName('arrow-left')[0].addEventListener('click', function () {
              this.parentNode.removeChild(this);
              Array.from(mobile_navs).forEach(e => {
                  e.style.height = '151px';
                  Array.from(e.parentNode.children).find(el => el instanceof HTMLDivElement).style.display = 'none';
                  e.style.display = 'block';
              })
          });
          
  
          var detail_cont = Array.from(this.parentNode.children).find(el => el instanceof HTMLDivElement);

          // open the first nav item details
          detail_cont.getElementsByClassName('nav-detail-item')[0].getElementsByClassName('details')[0].classList.remove('hidden');
  
          detail_cont.style.display = 'flex';
  
          Array.from(mobile_navs).forEach(n => {
              n.style.height = '66px';
              if (n.dataset.name != this.dataset.name) {
                  n.style.display = 'block';
                  Array.from(n.parentNode.children).find(el => el instanceof HTMLDivElement).style.display = 'none';
              }
          })
      });
  });
}